import React from 'react';
import { useTranslation } from 'react-i18next';
import RadialBarChart from '../components/RadialBarChart';

/**
 * 
 * @param {String} radialChartHeight - e.g. '225px' 
 * @param {String} radialChartWidth - e.g. '225px' 
 * @returns 
 */
export default function BenefitAmountAsPercentageOfTotalQE(_ref) {
  let {
    dashboardData,
    radialChartHeight,
    radialChartWidth
  } = _ref;
  const {
    t
  } = useTranslation();
  let benefitAmountAsPercentageOfTotalQE = [0];
  if (dashboardData.total_qualifying_rnd_expenditure > 0) {
    benefitAmountAsPercentageOfTotalQE = [window.MARKET_CONSTANTS.PERCENTAGE_FORMATTER.format(dashboardData.benefit_amount / dashboardData.total_qualifying_rnd_expenditure * 100)];
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadialBarChart, {
    percentage: benefitAmountAsPercentageOfTotalQE,
    text: t('chart_tax_benefit_as_%_of_qe'),
    height: radialChartHeight,
    width: radialChartWidth
  }));
}